export default "__VITE_ASSET__DEGuM5XS__"